import * as React from 'react';

function SvgArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.77 6.23L2 8l10 10L22 8l-1.77-1.77L12 14.46 3.77 6.23z" fill="currentColor" />
    </svg>
  );
}

export default SvgArrowDown;
